import React, { FC, memo } from 'react';
import { useLocation } from 'react-router';

import Typography from '@mui/material/Typography';

import Link from '@components/common/Link';

import { ROUTES_MOB } from '@constants/common/menu.constants';

import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const Explore: FC<Props> = ({ onClose }: Props) => {
  const { classes } = useStyles();
  const { pathname } = useLocation();

  return (
    <div className={classes.container}>
      <Typography
        variant="h4"
        color={(theme) => theme.palette.custom.text.dark}
      >
        Menu
      </Typography>
      {/*<div className={classes.explore}>*/}
      {/*  {ROUTES_MOB.map(({ title, href, isNewTab }) => {*/}
      {/*    const isActive = href === pathname;*/}
      {/*    return (*/}
      {/*      <Link*/}
      {/*        key={title}*/}
      {/*        pathname={href}*/}
      {/*        variant="subtitle1"*/}
      {/*        className={classes.link}*/}
      {/*        isNewTab={isNewTab}*/}
      {/*        color={(theme) => theme.palette.custom.text.dark}*/}
      {/*        activeColor={(theme) => theme.palette.custom.text.light}*/}
      {/*        isActive={isActive}*/}
      {/*        onClick={onClose}*/}
      {/*      >*/}
      {/*        {title}*/}
      {/*      </Link>*/}
      {/*    );*/}
      {/*  })}*/}
      {/*</div>*/}
    </div>
  );
};

export default memo(Explore);
